var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscardCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.4247V9.32259M16 21.6889V21.7513M24.9774 27.6663H7.02261C4.57008 27.6663 2.50038 26.0455 1.8492 23.8279C1.57123 22.8812 1.91278 21.8953 2.4352 21.0557L11.4126 4.86796C13.5159 1.48802 18.4841 1.48802 20.5874 4.86797L29.5648 21.0557C30.0872 21.8953 30.4288 22.8812 30.1508 23.8279C29.4996 26.0455 27.4299 27.6663 24.9774 27.6663Z",
    stroke: "#F96056",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardCarousel);
export default __webpack_public_path__ + "static/media/discard-carousel.2b674b28a5b3b008d5f8f5fc2628b992.svg";
export { ForwardRef as ReactComponent };